import { IDocumentEditable } from "../IDocumentEditable";
import { SpecifiedUserHisItemApplicator } from "./SpecifiedUserHisItemApplicator";

/**
 * 文書編集中に指導医を選択ダイアログから選択したとき、文書内のすべての指導医オブジェクトを連動して変更させる
 */
export class AttendingDoctorApplicator extends SpecifiedUserHisItemApplicator {
  constructor(document: IDocumentEditable) {
    super(document, "ATTENDING_DOCTOR");
  }
}
